const chatAttachment = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M3.25 3.8a3.55 3.55 0 1 1 7.1 0v6.067a2.15 2.15 0 0 1-4.3 0V3.983h1.5v5.884a.65.65 0 0 0 1.3 0V3.8a2.05 2.05 0 1 0-4.1 0v7a3.45 3.45 0 0 0 6.9 0V3.983h1.5V10.8a4.95 4.95 0 0 1-9.9 0z" clip-rule="evenodd"/></svg>',
};

export { chatAttachment as default };
